import {
  bilibiliProvider,
  dailymotionProvider,
  directVideoProvider,
  facebookProvider,
  instagramProvider,
  niconicoProvider,
  tiktokProvider,
  twitchProvider,
  vimeoProvider,
  youtubeProvider,
} from "./providers";
import { createVideoResolver } from "./resolve";

// Composition root: adding a provider does not change the player or drills UI.
export const resolveVideo = createVideoResolver([
  youtubeProvider,
  vimeoProvider,
  dailymotionProvider,
  twitchProvider,
  tiktokProvider,
  facebookProvider,
  instagramProvider,
  niconicoProvider,
  bilibiliProvider,
  directVideoProvider,
]);
